import { client } from "./client"
import { safeQueryOptions } from "@src/utils/query"
import { components } from "./schema"

export enum FormType {
  BlankForm = 0,
  StartupApplication = 1,
}

export const FORM_API_TYPE = {
  USER: "user",
  PROJECT: "project",
} as const

export type FormApiType = (typeof FORM_API_TYPE)[keyof typeof FORM_API_TYPE]

export const projectFormKeys = {
  all: ["projectForms"],
  list: (id?: number) => [...projectFormKeys.all, "list", "community", id],
  single: (id?: number) => [...projectFormKeys.all, "single", id],
}

export type ProjectFormResponse =
  components["schemas"]["FormDetailDtoResultListDto"]
export type ProjectFormDto = components["schemas"]["ProjectForm"]
export type ProjectFormQuestionDto =
  components["schemas"]["ProjectFormQuestion"]
export type ProjectFormAnswerDto = components["schemas"]["ProjectFormAnswer"]

export const getProjectForms = async (id: number) => {
  const data = await client.GET("/api/ProjectForm/GetAll", {
    params: { query: { communityId: id } },
  })

  return data
}

export const getProjectFormsQuery = (id?: number) =>
  safeQueryOptions({
    queryFn: getProjectForms,
    queryKeys: projectFormKeys.list(id),
    unsafeQueryFnArgs: [id],
  })

export const getProjectForm = async (id: number) => {
  const data = await client.GET("/api/ProjectForm/{id}", {
    params: {
      path: { id },
    },
  })

  return data
}

export const getProjectFormQuery = (id?: number) =>
  safeQueryOptions({
    queryFn: getProjectForm,
    queryKeys: projectFormKeys.single(id),
    unsafeQueryFnArgs: [id],
  })

export const saveProjectForm = async (payload: ProjectFormDto, id?: number) => {
  if (!id) {
    const data = await client.POST("/api/ProjectForm", {
      body: payload,
    })

    return data
  }

  const data = await client.PUT("/api/ProjectForm/{id}", {
    params: {
      path: { id },
    },
    body: payload,
  })

  return data
}

export const duplicateProjectForm = async (
  id: number,
  body: components["schemas"]["DuplicateFormDto"] = {},
) => {
  const data = await client.POST("/api/ProjectForm/{id}/Duplicate", {
    params: {
      path: { id },
    },
    body,
  })

  return data
}

export const deleteProjectForm = async (id: number) => {
  const data = await client.DELETE("/api/ProjectForm/{id}", {
    params: {
      path: { id },
    },
  })

  return data
}
